import React from 'react';
import { Block } from '../..';
import constants from '../../../../core/constants';
import { useRole } from '@/presentation/hooks/useRole';

const BottonZoom = (props: any) => {
  const { content, iconZoom, cardType } = props;
  const { isVisor } = useRole();
  return content?.detail?.link ? (
    <>
      {cardType !== constants.CARD_TYPES.CURSO_PRESENCIAL && (
        <Block>Conéctate a tu clase</Block>
      )}
      <Block customized>
        <a
          className={`buttonRemote fadeTransition ${isVisor ? 'disabled' : ''}`}
          href={content?.detail?.link}
          target="_blank"
          rel="noreferrer"
        >
          <Block className="label zoom" style={{ width: 'max-content' }}>
            <img src={iconZoom} alt="icon" />
            <div>Unirme a Zoom</div>
          </Block>
        </a>
      </Block>
    </>
  ) : null;
};

BottonZoom.defaultProps = {};

export default BottonZoom;
